import React from 'react';
import PropTypes from 'prop-types';
import Translate, { translate } from '@securitize/ui-components/i18n/Translate';
import { Button, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import ModalComponent from '../../../../../../../components/ModalComponent/ModalComponent';
import SecuritizeIdButton from '../../../../../../../components/SecuritizeIdButton';
import signAgreement from './signAgreement.svg';
import './CompleteVerificationModal.scss';
import { MixPanel } from '../../../../../../../utils/helpers/mixPanel';

const CompleteVerificationModal = (props) => {
  const {
    isOpen,
    onToggle,
    issuerConfig,
    user,
  } = props;

  const updatesRequired = user.verificationStatus === 'updates-required';

  return (
    <ModalComponent
      title={
        updatesRequired
          ? translate('Texts.updates-required-modal-title')
          : translate('Texts.provide-details-to-invest')
      }
      image={signAgreement}
      isOpen={isOpen}
      onToggle={onToggle}
      zIndex={10000}
      className="complete-verification-modal text-center"
      name="Complete details"
    >
      <p className="font-16 m-0 text-center">
        {
          updatesRequired
            ? <Translate translationKey="Texts.updates-required-modal-text" />
            : <Translate translationKey="Texts.provide-investor-details" />
        }
      </p>
      <ModalFooter className="border-0 p-0 flex-column mb-2">
        <SecuritizeIdButton
          id="btn-complete-verification"
          onClick={() => {
            MixPanel.track('kyc-required-click');
            const updatesRequiredUrl = new URL(`${issuerConfig.securitizeIdUrl}/profile/verification/type`);
            updatesRequiredUrl.searchParams.append('issuerId', issuerConfig.issuerId);
            updatesRequiredUrl.searchParams.append('scope', 'info details verification');
            updatesRequiredUrl.searchParams.append('redirecturl', `${window.location.href}`);
            const noneStatusRequiredUrl = new URL(`${issuerConfig.securitizeIdUrl}/profile/verification/type`);
            noneStatusRequiredUrl.searchParams.append('issuerId', issuerConfig.issuerId);
            noneStatusRequiredUrl.searchParams.append('scope', 'info details verification');
            noneStatusRequiredUrl.searchParams.append('redirecturl', `${window.location.href}?isProcessing=true`);
            window.location.href = updatesRequired ? updatesRequiredUrl : noneStatusRequiredUrl;
          }}
        >
          <span className="font-16 font-weight-semi">
            {
              updatesRequired
                ? <Translate translationKey="Texts.updates-required-modal-button" />
                : <Translate translationKey="Texts.complete-verification" />
            }
          </span>
        </SecuritizeIdButton>
        <Button
          id="btn-complete-verification-later"
          className="m-0 text-primary"
          color="link"
          size="lg"
          block
          onClick={onToggle}
        >
          <span className="font-16 font-weight-semi">
            <Translate translationKey="Texts.do-it-later" />
          </span>
        </Button>
      </ModalFooter>
    </ModalComponent>
  );
};

CompleteVerificationModal.defaultProps = {
  isOpen: false,
  onToggle: () => undefined,
  issuerConfig: {},
  user: {},
};

CompleteVerificationModal.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  issuerConfig: PropTypes.objectOf(PropTypes.any),
  user: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = ({ issuerConfiguration, auth }) => ({
  issuerConfig: issuerConfiguration.config || {},
  user: auth.user,
});

export default connect(mapStateToProps, {})(CompleteVerificationModal);
